import { render } from "./select.positions.vue?vue&type=template&id=4c058058&ts=true"
import script from "./select.positions.vue?vue&type=script&lang=ts"
export * from "./select.positions.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__